import React from "react";
import { useLocation } from "react-router-dom";
import Navb from "../../components/navbar/Navb";
import Trainebg from "./trainebg.png";
import Footer from "../../components/footer/Footer";
import Container from "react-bootstrap/Container";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "./trainee.css";
const SingleTrainee = () => {
  const location = useLocation();
  const trainee = location.state ? location.state.trainee : null;

  if (!trainee) {
    return <div>No trainee data available.</div>;
  }

  console.log("trainee", trainee);

  return (
    <>
      <Navb />
      <div className="traniee">
        <Container className="whiteHeading">Nandi Agro Trainee</Container>
        <Container className="whiteP">
          "Nandi Agro Trainee" refers to an individual undergoing training or
          apprenticeship within Nandi Agro, a company presumably involved in
          agriculture or related fields. As a trainee at Nandi Agro, one would
          have the opportunity to learn and develop skills in various aspects of
          agricultural practices. The training may include hands-on experience,
          classroom instruction, mentorship, and exposure to the latest trends
          and innovations in the agricultural industry. Nandi Agro is committed
          to nurturing and empowering future agricultural leaders, equipping
          trainees with the knowledge and expertise to contribute positively to
          the sector.
        </Container>
      </div>
      {/* <div className="singletranie">
        <h1>{trainee.name}</h1>
        <img src={trainee.Img} alt={trainee.name} />
        <p>Father's Name: {trainee.fathername}</p>
        <p>University: {trainee.University}</p>
        <p>Batch: {trainee.Batch}</p>
        <p>TrainingDate: {trainee.TrainingDate}</p>
      </div> */}
      <div className="trainee-card">
        <div className="traineecard">
          {/* <div className="row g-0"> */}
          <div className="imgtrainee">
            <img src={trainee.Img} className="img-fluid" alt={trainee.name} />
          </div>
          <div className="card-flexbody">
          <table className="">
              <tbody>
                <tr>
                  <th>Name:</th>
                  <td>{trainee.name}</td>
                </tr>
                <tr>
                  <th>Father's Name:</th>
                  <td>{trainee.fathername}</td>
                </tr>
                <tr>
                  <th>University:</th>
                  <td>{trainee.University}</td>
                </tr>
                <tr>
                  <th>Batch:</th>
                  <td>{trainee.Batch}</td>
                </tr>
                <tr>
                  <th>Training Date:</th>
                  <td>{trainee.TrainingDate}</td>
                </tr>
              </tbody>
            </table>
            {/* <div className="card-text">
              <p>Name: </p>
              <p>Father's Name: </p>
              <p>University: </p>
              <p>Batch: </p>
              <p>Training Date: </p>
            </div>
            <div className="card-body">
              <p>{trainee.name}</p>
              <p> {trainee.fathername}</p>
              <p> {trainee.University}</p>
              <p> {trainee.Batch}</p>
              <p>{trainee.TrainingDate}</p>
            </div> */}
          </div>
          {/* </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SingleTrainee;
